import { Box, Select, Option, Typography } from "@mui/joy";
import { useEffect, useState } from "react";
import { Paintbrush } from "lucide-react";

interface IItemPaintedDropdown {
    value: string | null;
    onChange: (value: string) => void;
    loading?: boolean;
    label?: string;
}

/**
 * Small reusable dropdown for "Painted" status on individual penetration items.
 */
export function ItemPaintedDropdown(props: IItemPaintedDropdown) {
    const { value, onChange, loading, label = "Painted" } = props;
    const [status, setStatus] = useState<string | null>(null);

    const handleUpdate = (event: any, newValue: string | null) => {
        if (loading) return;
        const selectedValue = newValue || "No";
        setStatus(selectedValue);
        onChange(selectedValue);
    };

    useEffect(() => {
        if (value) {
            setStatus(value);
        }
    }, [value]);

    return (
        <Box sx={{ minWidth: 100 }}>
            <Typography level="body-xs" sx={{ mb: 0.5 }}>{label}</Typography>
            <Select
                size="sm"
                placeholder="No"
                value={status}
                onChange={handleUpdate}
                disabled={loading}
                startDecorator={<Paintbrush size={14} />}
                slotProps={{ listbox: { sx: { zIndex: 10001 } } }}
            >
                <Option value="Yes">Yes</Option>
                <Option value="No">No</Option>
            </Select>
        </Box>
    );
}
